import { LegalLayout, LegalBlock } from "../components/LegalLayout";
import { EMAIL, PHONE } from "../data";

export default function PrivacyPolicy() {
  return (
    <LegalLayout title="Política de privacidad" updated="junio de 2026">
      <LegalBlock heading="1. Responsable del tratamiento">
        <p>
          El responsable del tratamiento de tus datos es <strong>Iván Hondal López</strong>
          (Ventanas Hondal), con domicilio en Renedo de Piélagos (Cantabria). Puedes
          contactar en {EMAIL} o en el teléfono {PHONE}.
        </p>
      </LegalBlock>

      <LegalBlock heading="2. Datos que recogemos">
        <p>
          A través de los formularios de la web (contacto, reserva de cita y solicitud de
          presupuesto) podemos recoger: nombre, correo electrónico, teléfono y la información
          que nos facilites en el mensaje o descripción del proyecto.
        </p>
      </LegalBlock>

      <LegalBlock heading="3. Finalidad">
        <p>
          Utilizamos tus datos únicamente para atender tu solicitud, elaborar presupuestos,
          gestionar citas y mantener el contacto necesario para prestarte el servicio.
        </p>
      </LegalBlock>

      <LegalBlock heading="4. Base legal">
        <p>
          La base legal es tu consentimiento, que otorgas al enviar el formulario, y la
          aplicación de medidas precontractuales a petición tuya.
        </p>
      </LegalBlock>

      <LegalBlock heading="5. Conservación y destinatarios">
        <p>
          Conservamos tus datos el tiempo necesario para atender tu solicitud y cumplir las
          obligaciones legales. No cedemos tus datos a terceros, salvo obligación legal. Los
          correos de aviso se gestionan mediante un proveedor de envío de email que actúa como
          encargado del tratamiento.
        </p>
      </LegalBlock>

      <LegalBlock heading="6. Tus derechos">
        <p>
          Puedes ejercer tus derechos de acceso, rectificación, supresión, oposición,
          limitación y portabilidad escribiendo a {EMAIL}. También tienes derecho a reclamar
          ante la Agencia Española de Protección de Datos (www.aepd.es).
        </p>
      </LegalBlock>

      <LegalBlock heading="7. Cookies">
        <p>
          Este sitio puede utilizar cookies técnicas y de analítica para entender cómo se usa
          la web y mejorarla. Puedes configurar o bloquear las cookies desde tu navegador.
        </p>
      </LegalBlock>
    </LegalLayout>
  );
}
